import React from 'react'
import {connect} from 'react-redux'

import ChatUIInfo from './chat_ui_info'
// import ChatHeaderActions from './chat_header_actions'
// import CloseButton from './close_button'
import UnreadMessageIndicator from './unread_message_indicator'

class ChatListHeader extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  renderUnreadMessageIndicator () {
    if (!this.props.shouldShowUnreadMessageIndicator) return

    return <UnreadMessageIndicator />
  }

  renderMinimizeButton () {
    if (!this.props.isMinimized && this.props.shouldShowMinimizeIndicator) {
      return (
        <div className='minimize-button'>
          <i className='rc-icon-minimize'/>
        </div>
      )
    }
  }

  render () {
    return (
      <div className='chat-list-header' onClick={this.props.onClick} style={{backgroundColor: this.props.headerBackground}}>
        <ChatUIInfo />
        {this.renderUnreadMessageIndicator()}
        {this.renderMinimizeButton()}
      </div>
    )
  }
}

ChatListHeader.defaultProps = {
  shouldShowMinimizeIndicator: true
}

const mapStateToProps = (state) => {
  return {
    headerBackground: state.getIn(['chatSettings', 'colors', 'chatList', 'headerBackground'])
  }
}

const ChatListHeaderContainer = connect(
  mapStateToProps
)(ChatListHeader)

export default ChatListHeaderContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_list_header.js
 **/